import { Button } from '@/components/ui/button';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useToast } from '@/components/ui/use-toast';
import { useLocale } from '@/lib/hooks/use-locale';
import { CopyIcon } from 'lucide-react';
import { useCopyToClipboard } from 'usehooks-ts';

const useCopy = (textToCopy: string) => {
    const [_, copy] = useCopyToClipboard();
    const { toast } = useToast();
    const { t } = useLocale();

    const onCopy = () => {
        copy(textToCopy);

        toast({
            icon: 'success',
            title: t('copy_successful', { ns: 'toasts' }),
        });
    };

    return { onCopy, t };
};

type CopyButtonProps = {
    className?: string;
    title?: string;
    textToCopy: string;
};

export const CopyButton: React.FC<CopyButtonProps> = ({ className, textToCopy, title }) => {
    const { onCopy, t } = useCopy(textToCopy);

    return (
        <Button
            className={className}
            icon={CopyIcon}
            variant={title !== '' ? 'subtle' : 'icon'}
            onClick={onCopy}
        >
            {title === undefined
                ? t('copy_id', {
                      ns: 'common',
                  })
                : title}
        </Button>
    );
};

type DropdownMenuItemCopyProps = {
    textToCopy: string;
    className?: string;
};

export const DropdownMenuItemCopy: React.FC<DropdownMenuItemCopyProps> = ({ textToCopy, className }) => {
    const { onCopy, t } = useCopy(textToCopy);

    return (
        <DropdownMenuItem onSelect={onCopy} className={className}>
            <CopyIcon className="h-4 w-4" />
            <span>{t('copy_id', { ns: 'common' })}</span>
        </DropdownMenuItem>
    );
};
